export default {
  env: 'pro',
  baseUrl: 'https://nextwxapp.aosmarketing.com.cn/',
  appId: 'wx3962a8c2ee7612a5',
  originId: 'gh_83988bd24741',
  materialUrl: 'https://moawx.hotwater.com.cn/',
  activityUrl: 'https://nextm.aosmarketing.com.cn/campaign/#/activitydetail',
  privacyUrl: 'https://nextwxapp.aosmarketing.com.cn/private.html',
  agentId: '1000067',
  customAppId: 'wx3962a8c2ee7612a5',
  h5Url: 'https://nextm.aosmarketing.com.cn/campaign/#/',
  AJNmultiChannelId:'YISEN_AJN',//艾锦囊多渠道id
}